const steps = {
    ADDRESS_STANDARD: 0,
    BILL: 1,
    HOUSE: 2,
    CONFIRM: 3,
};

export const StepIndicator = ({currentStep}) => {
    const arr = [...Array(4).keys()];

    return (
        <div className="steps-container">
            {arr.map((_, i) => (
                <div key={i} className={`step ${i <= steps[currentStep] ? 'active' : ''}`}></div>
            ))}
        </div>
    );
};
